import axios from 'axios'
import store from '@/store'

// axios.defaults.withCredentials = true
const openApi = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
      'AppKey': process.env.VUE_APP_API_KEY,
      "Content-Type": "application/json"
    }
})

openApi.interceptors.request.use(config => {
  if (store.state.user.userToken && config.data) {
    config.data.userName = store.state.user.userToken
  }
  // 设置 X-P-Recommend 请求头
  if (store.state.user.userToken) {
    const recommendValue = localStorage.getItem('isAcceptPersonalRecommend')
    if (recommendValue !== null) {
      config.headers['X-P-Recommend'] = recommendValue === 'true' ? '1' : '0'
    } else {
      // 线上已经登录用户默认已接受推送
      config.headers['X-P-Recommend'] = '1'
    }
  }
  return config
}, error => {
  return Promise.reject(error)
})
  
// response interceptor
openApi.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const { response } = error
    return response ? response.data : Promise.reject(error)
  }
)

  
export { openApi }